export default __webpack_public_path__ + "static/gift-card-2.url-8f698b8be0120d4336ea9bf56bcc6238.svg";